import React from 'react';
import SkeletonComponent from './SkeletonComponent.jsx';
import "react-loading-skeleton/dist/skeleton.css";

const CenteredSkeleton = ({width = '100%', height = '100%', ...rest}) => {
  return (
    <div style={{width: '100%', height: '100%', position: 'relative'}}>
      <SkeletonComponent variant='rectangular' width={width} height={height} className='centered-skeleton' {...rest}/>
    </div>
  )
}

export default CenteredSkeleton;
